import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { ThemeProvider, useTheme } from '@mui/material/styles';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import { ContextNotification, severitys } from "../../../App";
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import EditFlightComNutrition from './EditFlightComNutrition';
import EditFlightComTransport from './EditFlightComTransport';
import EditFlightComAccomodation from "./EditFlightComAccomodation";
import { useNavigate, useParams } from "react-router-dom";
import brokerGroupApi from "../../../api/brokerGroupApi";
import CustomTitle from "../../../Components/CustomTitle";
import { MdAirlines } from "react-icons/md";
import { TfiBackRight } from "react-icons/tfi";
import { IconButton } from "@mui/material";



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
const FlightCompensation = () => {

    const theme = useTheme();
    const [tabvalue, setTabValue] = useState(0);
    const { setOpen } = useContext(ContextNotification);
    const customization = useSelector((state) => state.customization);
    const [flightData, setFlightData] = useState(null);
    const [flightInfo,setFlightInfo]=useState('');
    const { id } = useParams();
    const navigate = useNavigate();

    const GetGroupsData = () => {
        brokerGroupApi.GetFlightGroupsAndPassengers(id)
            .then((res) => {
                setFlightData(res.data.data);
            }
            )
            .catch(err => {
               
            
                            if (err.response && err.response.data) {
                                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                            }
                            else if (err.response && err.response.data && err.response.data.errors) {
                                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                            }
                            else if (err.message) {
                                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                            }
    });
    }
    const GetFlightInfo=()=>{
        var infoText='';
        brokerGroupApi.GetFlightById(id)
            .then((res) => {
               
                   infoText= res.data.data.flightNo+' - '+res.data.data.flightDatePersian;
                   
            }
            )
            .catch((error) => console.log(error))
            .finally(()=>{ setFlightInfo(infoText);});
    }
    const resetForm = () => {
        setTabValue(0);
    }

    useEffect(() => {
        GetGroupsData();
        GetFlightInfo();
    }, []);

    function a11yProps(index) {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const GoToFlightList = () => {
        navigate('/dashboard/DelayPanel/DelayList');
    }

    return (
        <ThemeProvider theme={customtheme(customization)}>

            <IconButton
                sx={{ fontSize: '0.7rem', fontWeight: 'bold' }}

                color="inherit" onClick={() => { GoToFlightList() }}>
                <Typography component="h1" variant="h5" sx={{ display: "flex", alignItems: "center", fontSize: '12px' }}>
                    بازگشت به لیست پرواز              </Typography>
                < TfiBackRight size={20} />
            </IconButton>
            <RtlProvider>
                <CustomTitle title={' هزینه تاخیر پرواز شماره '+flightInfo} icon={<MdAirlines size={24} />} />

                <Box sx={{ bgcolor: 'background.paper' }}>
                    <AppBar position="static">
                        <Tabs
                            value={tabvalue}
                            onChange={handleChange}
                            indicatorColor="secondary"
                            textColor="inherit"
                            variant="fullWidth"
                            aria-label=""
                        >
                            <Tab label="خدمات اسکان" {...a11yProps(0)} />
                            <Tab label="خدمات تغذیه" {...a11yProps(1)} />
                            <Tab label="خدمات حمل و نقل" {...a11yProps(2)} />
                        </Tabs>
                    </AppBar>
                    <TabPanel value={tabvalue} index={0} dir={theme.direction}>
                        <EditFlightComAccomodation flightData={flightData} />
                    </TabPanel>
                    <TabPanel value={tabvalue} index={1} dir={theme.direction}>
                        <EditFlightComNutrition flightData={flightData} />
                    </TabPanel>
                    <TabPanel value={tabvalue} index={2} dir={theme.direction}>
                        <EditFlightComTransport flightData={flightData} />
                    </TabPanel>


                </Box>
            </RtlProvider>
        </ThemeProvider>
    );
}
export default FlightCompensation